import React from 'react';

import moment from 'moment';
import { connect } from 'react-redux';
import { AnyAction } from 'redux';
import { ThunkDispatch } from 'redux-thunk';

import IconButton from '@material-ui/core/IconButton';
import Tooltip from '@material-ui/core/Tooltip';

import { updateEmployeeDirectoryImport } from '../actions/update-employee-directory-import';

import { ICON_NAMES, MaterialDesignIcon } from '../../util/material-design-icons';
import { confirm } from '../../widgets/confirmation-dialog';

type InputProps = {
  employeeDirectoryImportId: number;
};

const mapDispatchToProps = (dispatch: ThunkDispatch<any, any, AnyAction>) => ({
  actions: {
    markImportComplete: (employeeDirectoryImportId: number) =>
      dispatch(
        updateEmployeeDirectoryImport(employeeDirectoryImportId, {
          completedAt: moment.utc(),
        }),
      ),
  },
});

type DispatchProps = ReturnType<typeof mapDispatchToProps>;
type Props = InputProps & DispatchProps;

export const EmployeeDirectoryImportMarkCompleteButton = connect(
  null,
  mapDispatchToProps,
)(({ employeeDirectoryImportId, actions }: Props) => {
  const markImportComplete = async () => {
    if (
      await confirm(
        'This import has not been completed. Are you sure you want to mark this employee list complete?',
      )
    ) {
      await actions.markImportComplete(employeeDirectoryImportId);
    }
  };

  return (
    <Tooltip title="Mark Complete">
      <IconButton onClick={markImportComplete}>
        <MaterialDesignIcon iconName={ICON_NAMES.CHECK} />
      </IconButton>
    </Tooltip>
  );
});
